// extracted by mini-css-extract-plugin
export default {"container":"BP-z","topReviewHeading":"CP-z","criticalReview":"DP-z","favorableReview":"EP-z","vsSeparator":"FP-z"};